import { readStoredRoleKeys } from "@/Utile/aiAssist.mjs";

export const canConvertCompanies = (roles = readStoredRoleKeys()) =>
  roles.some((role) => ["crm-operator", "crm-admin", "admin", "miniadmin"].includes(role));
export const conversionName = (record) => [record?.name, record?.source]
  .map((value) => String(value || "").trim()).filter(Boolean).join(" — ");
export const conversionFailureKey = (code) => [
  "conversion_name_too_long", "conversion_linked_records", "conversion_privacy_history",
  "conversion_not_found", "conversion_invalid_contact", "conversion_changed",
].includes(code) ? code : "conversion_failed";
